export default {
  website: {
    shoutoutSliderText1:
      'Ligue 1、Serie A、Bundesliga、Premier League、NFL、NBA、NCAA などの試合をストリーミング配信!',
    'shoutout!': 'シャウト!',
    loveTheGame: 'ゲームが大好き。自分のものにしましょう。',
    joinTheDedicated:
      '専用のスポーツ ソーシャル ネットワークに参加してください。これは、スポンサーとパートナーによって強化されたエコシステムです。',
    aSportsCommunity: 'スポーツコミュニティマーケットプレイス。',
    athletesMonetize: 'アスリートはブランドを収益化します。',
    fansConnectDirectly: 'ファンはアスリートと直接つながります。',
    ledByAthletes: 'アスリート主導。',
    ledByFans: 'ファン主導。',
    ledBy: 'によって導かれた',
    'athletes.': 'アスリート',
    'fans.': 'ファン',
    goToApp: 'アプリに移動',
    logout: 'ログアウト',
    amAnAthlete: '私はアスリートです',
    monetizeYourBrand: 'ファンと一緒にユニークな世界を作り、ブランドを収益化しましょう。',
    amAFan: '私はファンです',
    connectDirectlyWith: 'お気に入りのアスリートや他のファンと直接つながりましょう。',
    athleteZone: 'アスリートゾーン',
    fanZone: 'ファンゾーン',
    ourAthletes: '私たちのアスリート',
    news: 'ニュース',
    ourStory: '私たちの物語',
    sponsors: 'スポンサー',
    contact: 'コンタクト',
    athleteFocus: 'アスリートにフォーカスした',
    calculator: '電卓',
    seeHowMuch: 'あなたのブランドがあなたにどれだけの利益をもたらすか見てみましょう。',
    weAllPlay: '私たち全員で、より良いプレーをします。',
    everybody: '皆さんが',
    playsBetter: 'より良いプレイ',
    weAll: '私たちは皆',
    playBetter: 'より良いプレイ',
    together: '一緒に',
    video: '動画',
    tiffanyVan: 'ティファニー・ヴァン・ゾースト',
    goto: '次のページへ',
    athleteZoneSmall: 'アスリートゾーン',
    latestNews: '最新ニュース',
    ledByPartners: 'パートナー主導。',
    partnersAndSponsors: 'パートナーとスポンサー',
    ledByTeams: 'チーム主導。',
    seeOurWork: 'これらのトップアスリートとの私たちの仕事をご覧ください',
    sportsCareer:
      'スポーツのキャリアは短いかもしれませんが、あなたは一生の経験を積んでいます.今こそ報酬を得る時です。',
    buildAnOngoing: '継続的かつ持続的な収入を得る',
    takeControl: 'あなたのブランドとあなたの未来を自分の手で作り上げましょう。',
    signUpForFree:
      '無料会員登録すると、あなたのキャリアがどのぐらいの収益をあげられるかを計算することができます。',
    'connect!': 'つながる!',
    unlimitedAccess:
      'お気に入りのアスリートに無制限にアクセスできます。スポーツヒーローの独自のネットワークを構築しましょう！',
    'stream!': 'ストリーム!',
    streamGamesFrom:
      'Ligue 1、Serie A、Bundesliga、Premier League、NFL、NBA、NCAA などの試合をストリーミング配信!',
    stayVisible: '常に見えるように。',
    connectWithUs: '私たちとつながる',
    newsletter: 'ニュースレター',
    typeEmail: 'ここにEメールを入力し、Enterキーを押してください。',
    typeAndEnter: 'ここにEメールを入力し、Enterキーを押してください。',
    wedLoveTo: 'ぜひ、ご意見をお聞かせください。',
    sendUsAMessage: 'メッセージを送ってください',
    notAnAthleteOrFan: 'アスリートやファンではありませんか？',
    connectWithUsHere: 'ここで私たちとつながりましょう！',
    home: 'ホーム',
    fanZoneSmall: 'ファンゾーン',
    ourStorySmall: '私たちの物語',
    ourAthletesSmall: '私たちのアスリート',
    selectCountry: '国を選択',
    signUp: 'サインアップ',
    stopTheHate: 'ヘイトは禁止です',
    termsAndConditions: '規約と条件',
    privacyPolicy: 'プライバシーポリシー',
    playaz4playaz: 'プレイアズ4プレイアズ',
    allRigthsReserved: '無断転載禁止',
    led: '導いた',
    byTopAthletes: 'トップアスリートによる',
    partners: 'パートナー',
    investors: '投資家',
    attendees: '参加者',
    date: '4月26日～29日',
    location: 'フロリダ州ウェズリー チャペル',
    dontMiss: 'お見逃しなく',
    outOn: 'OUT ON',
    your: 'あなたの',
    timeToShine: '輝く時間。',
    registerForCombine: 'コンバインに登録する',
    registrationEnds: '登録終了',
    days: '日',
    hours: '時間',
    minutes: '分',
    seconds: '秒',
    ourPartners: '私たちのパートナー。',
    enjoyTheseMembership: 'これらの素晴らしいメンバーシップ機能をお楽しみください',
    sportUnites: 'スポーツの団結。',
    noDivide: '分けない。',
    videosArticles: 'スポーツスターのビデオ、記事、インタビュー',
    instantMessaging: 'お気に入りのアスリートとのインスタント メッセージ',
    discountOnEvent: 'イベントチケットとグッズの割引',
    behindTheScenes: 'スポーツ界の舞台裏に迫る',
    experienceSport: '好きな方法でスポーツを体験してください。',
    theOnlySportsApp:
      'お気に入りのアスリートとリアルタイムで直接連絡できる唯一のスポーツ アプリです。',
    buildYourOwnWorld: 'アスリートと直接つながることで、自分だけの世界を作ることができます。',
    chooseTheFeatures: 'お好きな機能をお選びください。',
    interactWithAthletes: 'アスリートと交流して、刺激を受けましょう！',
    sendAShoutout: '試合の直前、または試合中にアスリートやチームにエールを送りましょう!',
    fanLife: '#ファンライフ',
    highlights: 'ハイライト',
    recentArticles: '最近の記事',
    p4pxIra: 'p4p x アイラ・ブラウン',
    uploadedDate: '2022 年 2 月 28 日にアップロード',
    youMightAlso: 'こちらもおすすめ...',
    'subscribe!': '購読する！',
    getContent:
      'Playaz4playazで、お気に入りのスポーツ、またはすべてのスポーツのコンテンツとストリーミングを手に入れましょう。',
    'vipConnects!': 'VIPコネクト!',
    '1-to-1connections':
      'バーチャルまたは対面で、お気に入りのアスリートと 1 対 1 でつながることができます。',
    watch: 'ウォッチ：P4Pストーリー',
    caseStudies: 'ケーススタディ',
    aboutHenrySeals:
      'ハーバード大学を卒業したヘンリーは、経験豊富なピープルリーダーです。現在は、デジタルとハイブリッドのエンゲージメントを通じてクリエイターのファン獲得をサポートする日本のスタートアップ、ZaikoのCHROを務めています。  また、日本初の外国人人権擁護委員であり、レガシー基金ジャパンの設立者でもあります。 \u000bPaidyのCHROとして、同社を日本で唯一のユニコーン（評価額10億ドル企業）の1つにし、2021年の株式上場に貢献しました。\nまた、Philip Morris International、AIG、NNで人事の上級職を歴任した経験も有しています。\n\n',
    aboutHoustonRoss:
      'ヒューストンは、グローバル企業において、将来に向けた準備、オペレーションとインフラの近代化、高いパフォーマンスを発揮するチームの育成を長年リードしてきた経験を有しています。  最近では、日本のBNPLユニコーンのPaidyでCTOを務め、同組織を株式公開に向けて成功裏に導きました。\nまた、アクサ生命、ING、NNなどのグローバル金融機関においてCTOを務めるなど、グローバルリーダーとして活躍しています。  \nスポーツ好きで、テクノロジー、ファイナンス、オペレーショナルエクセレンスの経験を生かし、P4Pをグローバルリーダーにすることを目指しています。',
    aboutJuliusGoldsmith:
      'Juliusは、ビジネス開発、新製品開発、クロスボーダー取引の分野で20年以上ウォール街で経験を積んだ弁護士です。ニューヨーク、ロンドン、シンガポール、東京での勤務経験があり、事業開発、財務、法務、税務関連など複数の分野で豊富な経験を有しています。  母校であるフェアレイ・ディキンソン大学のシルバーマン・ビジネス・カレッジの学部長顧問であり、公認会計士の資格も有しています。  ',
    aboutMarcelVanDruten:
      'マルセル・ヴァン・ドゥルーテンは、グローバルな技術環境において実績を積んできたベテランのプロフェッショナルです。オランダのアムステルダムで生まれ育ち、21歳までアマチュア最高峰のサッカークラブで精悍な顔つきのディフェンダーとして活躍しました。 \nマーケティングと広告に関する深い専門知識を生かし、グローバルブランドの収益向上とブランド認知度向上を目的としたプログラムやイニシアチブの開発・実施を支援してきました。英語、オランダ語、ドイツ語のマルチリンガルで、格闘技、ゴルフ、フォーミュラ1への情熱を持っているマルセルは、P4Pが世界一のスポーツアプリになるようサポートしています。\n',
    aboutMichaelAJacobs:
      'マイケルは、上級管理職および法律の専門家であり、優れた地域社会への関与、人事、労使関係、法律に関する経験を通じて、複数サイトの運営を改善する多様な実績を有しています。  現在、ニューヨーク大学ロバート・F・ワグナー公共サービス大学院の上級講師とニューヨーク市立大学専門職大学院の非常勤准教授を務めています。  又、メリーランド大学グローバルキャンパス（旧メリーランド大学カレッジ）とハワード大学ロースクールで非常勤講師を務めた経験もあります。 \n',
    aboutMichaelJackson:
      'コロンビア大学を卒業した Michael は、経験豊富なプロダクト マネージャーであり、グローバルな資産および資産管理組織のデリバリーの地域責任者を務めていました。彼は、運用効率とサービス\/製品の提供を改善することを目的としたグローバルプロジェクトを長年提供してきた経験を持っています. \n\n',
    sponsorsSmall: 'スポンサー',
    becomeASponsor: 'P4Pスポンサーになる',
    content1: 'Lorem ipsum...',
    content2: 'ロレム・イプサム...',
    ourTeams: '私たちのチーム',
    paymentDetails: '支払明細',
    cancelWithin30Days:
      '30 日以内にキャンセルすると、カードへの請求は行われません。基本的な機能には引き続きアクセスできます。',
    cardNumber: 'カード番号',
    expiry: '有効 期限',
    cvc: 'セキュリティコード',
    illDoItLater: '後でやる',
    submit: '送信',
    athleteInformation: 'アスリート情報',
    contactInformation: '連絡先',
    otherInformation: 'その他の情報',
    dateOfBirth: '生年月日',
    year: '年',
    month: '月',
    day: '日',
    socialNetworks: 'ソーシャルネットワーク',
    Instagram: 'インスタグラム',
    facebook: 'フェイスブック',
    twitter: 'ツイッター',
    uploadHeadshot: '顔写真またはバスケットボールのアクションショットをアップロードする',
    phoneNumber: '電話番号',
    sport: 'スポーツ',
    linkInstagram: 'Instagram プロフィールへのリンク',
    linkFacebook: 'Facebook プロフィールへのリンク',
    linkTwitter: 'Twiiter プロフィールへのリンク',
    athleteSignUp: 'アスリートサインアップ',
    thankYou: 'ありがとうございます',
    youWillBeSent: 'まもなく確認メールが送信されます。',
    getTheApp: 'アプリを取得',
    or: '又は',
    continueOnWebsite: 'ウェブサイトで続行',
    welcome: 'ようこそ！',
    '30dayFull': '30日間フルアクセス！',
    enjoyTheseAmazing: 'これらの素晴らしい機能を無料でお楽しみください。条件はありません。',
    yesGiveMe: 'はい、無料のアクセス権を希望します!',
    noThanksKeep: '結構です、基本的なものにしてください',
    letsWorkTogether: '一緒に働きませんか！詳細をご記入ください。こちらからご連絡いたします。',
    yourDetails: 'あなたの詳細内容',
    firstName: 'ファーストネーム',
    lastName: '苗字',
    emailAddress: 'メールアドレス',
    companyInformation: '会社情報',
    companyName: '会社名',
    companyWebsite: '会社ホームページ',
    login: 'ログイン',
    getApp: 'アプリを入手',
    letsTalk: '話しましょう',
    sponsor: 'スポンサー',
    useTheApp: 'アプリを使用する',
    messageSent: 'メッセージが正常に送信されました。',
    invalidEmail: 'メールが無効です。',
    addedToNewsletter: 'メールがニュースレターに正常に追加されました。',
    recently: '最近',
    aboutAyannaColeman: 'lorem ipsum...'
  }
};
